import { useCanOpenStep, useExperienceChat } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Button } from '@cascade/ui-library';
import classes from './HelpButton.module.scss';
import type { THelpButtonProps } from './HelpButton.types.ts';

export const HelpButton = ({ prompt }: THelpButtonProps) => {
  const { translate } = useI18n();
  const canOpenStep = useCanOpenStep();
  const { ask } = useExperienceChat();

  const askForHelp = () => {
    ask({ question: prompt }).catch(() => undefined);
  };

  return (
    <Button
      className={classes['help-button']}
      variant='info'
      size='sm'
      iconType='question'
      iconOnly
      label={translate('experience.help')}
      disabled={!canOpenStep}
      onClick={askForHelp}
    />
  );
};
